import React from "react"
import styled, { keyframes, css } from "styled-components"
import { media } from "../../../../components/mediaStylesNew"
import { colors } from "../../../../components/Color"
import ErrorIcon from "../ErrorIcon"

const clickAnimation = keyframes`
  0% {
    box-shadow: 0 2px 4x 0 rgba(0, 0, 0, 0.3);
  }
  
  50% {
    box-shadow: 0 1px 0px 0 rgba(0, 0, 0, 0.3);
  }
  
  100% {
    box-shadow: 0 2px 4x 0 rgba(0, 0, 0, 0.3);
  }
`

const Tile = styled.div`
  position: relative;
  font-family: GT America, sans-serif;
  width: 100%;
  min-height: 40px;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 13px;
  font-weight: 500;
  font-size: 14px;

  color: ${props => props.selected && colors.white};
  background: ${props => (props.selected ? colors.coal : colors.beige)};

  ${props => {
    if (props.selected) {
      return css`
        animation: ${clickAnimation} 0.4s ease-out;
      `
    }
  }}

  ${media.desktop`
    margin-left: 0px;
    
    &:hover {
      color: ${colors.white};
      background: ${colors.coal};
      cursor: pointer;
    }
    `}

  &:active {
    color: ${colors.white};
    background: ${colors.teal};
    cursor: pointer;
  }
`

const Error = styled.div`
  position: absolute;
  top: 0;
  right: 10px;
`
export default ({
  name,
  value,
  onSelect = () => {},
  selected = false,
  hasError = false,
}) => {
  return (
    <Tile
      onClick={() => onSelect(value)}
      selected={selected}
      tabIndex={0}
      onKeyDown={event => {
        if (event.keyCode === 13) {
          onSelect(value)
        }
      }}
    >
      {name}
      {hasError && (
        <Error>
          <ErrorIcon />
        </Error>
      )}
    </Tile>
  )
}
